import React from 'react';
import {
  FooterContainer,
  FooterContent,
  RelevantLinks,
  SocialWrapper,
  MapWrapper,
  LogoWrapper,
} from './styles';
import MapSVG from '../../../styles/svgs/map.svg';
import Logo from '../../../styles/svgs/white_logo.svg';
import Link from 'next/link';
import { FaInstagram, FaLinkedin } from 'react-icons/fa';
import { Menu } from '../../../types/schema';

export type Item = {
  label: string;
  url: string;
};

export type MenuType = {
  title?: string;
  locale: string;
  items: Item[];
};

export type FooterTemplateProps = {
  data: {
    technologies: Menu[];
    footerPt: Menu[];
    footerEn: Menu[];
    services: Menu[];
  };
  locale: string;
};

const FooterTemplate: React.FC<FooterTemplateProps> = ({ data, locale }) => {
  const isEn = locale === 'en';

  const menu = isEn ? (data.footerEn[0] as MenuType) : (data.footerPt[0] as MenuType);
  const services = data.services[0] as MenuType;
  const technologies = data.technologies[0] as MenuType;

  const allMenus = isEn ? data.footerEn : data.footerPt;
  const takeAction = allMenus.find((menu) => menu.title?.includes('take action'));

  return (
    <FooterContainer>
      <FooterContent>
        <div className="container-items">
          <LogoWrapper>
            <Link
              href={`/${locale || ''}`}
              className="logo"
              title={isEn ? 'Go to home page' : 'Ir para a página inicial'}
            >
              <Logo />
              <span hidden>App Masters</span>
            </Link>
          </LogoWrapper>

          <p className="footer-title">{isEn ? 'Follow us!' : 'Siga-nos!'}</p>
          <SocialWrapper>
            <a
              href="https://www.instagram.com/appmasters.io/"
              target="_blank"
              rel="noopener noreferrer external nofollow"
              title="Instagram"
            >
              <FaInstagram />
            </a>
            <a
              href="https://www.linkedin.com/company/appmasters.io/"
              target="_blank"
              rel="noopener noreferrer external nofollow"
              title="LinkedIn"
            >
              <FaLinkedin />
            </a>
          </SocialWrapper>
        </div>
        {isEn && (
          <div className="container-items">
            <p className="footer-title">{services?.title}</p>
            <RelevantLinks>
              {services &&
                services.items?.map((service) => (
                  <Link key={service.label} href={service.url}>
                    {service.label}
                  </Link>
                ))}
            </RelevantLinks>

            <p className="footer-title">{technologies?.title}</p>
            <RelevantLinks>
              {technologies?.items?.map((technology) => (
                <Link key={technology.label} href={technology.url}>
                  {technology.label}
                </Link>
              ))}
            </RelevantLinks>
          </div>
        )}
        <div>
          <p className="footer-title">{isEn ? menu?.title : 'Links relevantes'}</p>
          <RelevantLinks>
            {menu &&
              menu.items?.map((item) => (
                <Link href={item.url} key={item.label}>
                  {item.label}
                </Link>
              ))}
          </RelevantLinks>
        </div>
        <div>
          {takeAction && takeAction.items && takeAction.items.length > 0 && (
            <>
              <p className="footer-title">{isEn ? 'Take action' : 'Agir agora'}</p>
              <RelevantLinks>
                {takeAction.items.map((item) => (
                  <Link href={item?.url as string} key={item?.label}>
                    {item?.label}
                  </Link>
                ))}
              </RelevantLinks>
            </>
          )}
        </div>
        <div>
          <p className="footer-title">{isEn ? 'Address' : 'Endereço'}</p>
          {isEn ? (
            <p>
              900 Presidente Juscelino Kubitschek Avenue
              <br />
              8th Floor – Moinho
              <br />
              Francisco Bernardino Neighborhood
              <br />
              Juiz de Fora - MG - Brazil
              <br />
              ZIP Code 36081-000
            </p>
          ) : (
            <p>
              Av. Presidente Juscelino Kubitschek, 900
              <br />
              Oitavo andar - Moinho
              <br />
              Bairro Francisco Bernardino
              <br />
              Juiz de Fora - MG
              <br />
              CEP 36081-000
            </p>
          )}
          <MapWrapper>
            <br />
            <a
              href="https://www.google.com.br/maps/place/App+Masters/@-21.7725999,-43.3486377,17z/data=!3m1!4b1!4m5!3m4!1s0x989b5d3104ae57:0x9216e0df6326e89f!8m2!3d-21.7725999!4d-43.3471735"
              target="_blank"
              rel="noopener noreferrer external nofollow"
              title={isEn ? 'Our location on Google maps' : 'Nossa localização no Google maps'}
            >
              <MapSVG />
            </a>
          </MapWrapper>
        </div>
      </FooterContent>
    </FooterContainer>
  );
};

export default FooterTemplate;
